import btecToken from "../abis/development/tokens/btecToken";

export default {
  name: "BTEC",
  abi: btecToken.abi,
  contractAddress: "0xAf307c4Ea25c8d2A7029Dc0322396A6b4B00A0Fc",
  decimals: 9,
};
